module.exports = __webpack_public_path__ + "img/LX_BLACK_MATT_RIM_YELLOW_0006.46d07a59.png";